module.exports = __webpack_public_path__ + "img/chart.31a482ee.svg";